import React, { Component } from 'react';

class FacebookUIShare extends Component {
    constructor(props){
        super(props);
        
        this.handleClick = this.handleClick.bind(this);
    }
    
    handleClick(event){
        event.preventDefault();

        const globalFB = window['FB'];

        if(typeof this.props.clickCallback === 'function'){
            this.props.clickCallback.call(null, event);
        }

        if(typeof globalFB !== 'undefined' && typeof globalFB.ui !== 'undefined') {
            globalFB.ui({
                method: 'share_open_graph',
                action_type: 'og.likes',
                action_properties: JSON.stringify({
                    object: {
                        'og:url': this.props.url,
                        'og:title': this.props.title,
                        'og:image': this.props.image,
                        'og:description': this.props.description
                    }
                })
            }, function (response) {
            });
        }
        return false;
    }

    render(){
        return(
          <div className="isg_share_button" onClick={this.handleClick}>
              {this.props.children}
          </div>
        );
    }
}

FacebookUIShare.propTypes = {
    children: React.PropTypes.node,
    url: React.PropTypes.string.isRequired,
    title: React.PropTypes.string.isRequired,
    image: React.PropTypes.string.isRequired,
    description: React.PropTypes.string.isRequired,
    clickCallback: React.PropTypes.func
};

export default FacebookUIShare;


/** WEBPACK FOOTER **
 ** ./src/components/FacebookUIShare.js
 **/